// Copyright (c) StrangeBee 2023

import { DescribeOutput, TaskStatus, QuerySelector } from 'thehive-sdk';

interface ComputeListSelectorParams {
    describeData?: DescribeOutput;
}

export const computeListSelector = ({ describeData }: ComputeListSelectorParams): QuerySelector => ({
    head: [{ name: 'listTask' }, { name: 'inCase' }],
    extraData: ['actionRequired', 'shareCount', 'case'],
    name: `get-global-tasks`,
    initialFilters: [
        {
            field: 'status',
            operator: 'not',
            values: [TaskStatus.CANCEL],
            type: 'string',
            describeAttribute: describeData?.task.attributes.find(({ name }) => name === 'status') as any,
        },
    ],
    sort: ['-flag', '-startDate'],
});
